import React, { useState, useContext, useEffect } from 'react'
import './styles.scss'

import createNumberMask from 'text-mask-addons/dist/createNumberMask'

import contractContext from '../../../../../store/contexts/contractContext'
import CONTRACT_ACTIONS from '../../../../../store/actions/contractActions'

import GeneralInputMask from '../../../../../components/GeneralInputMask'
import ResultBox from '../../../../../components/ResultBox'
import Toggle from '../../../../../components/Toggle'
import Button from '../../../../../components/Button'

import { currencyStringToFloat, currencyFloatToString } from '../../../../../helpers/currency'
import { getPropertyAnnouncement } from 'services/announcements'
import { PropertyAnnouncement } from 'types/propertyAnnouncement'

const toggleLabels = {
  nonToggled: 'DONO PAGA',
  toggled: 'MORADOR PAGA',
}

export default function NegotiatedConditions() {
  const { contract, handleStepChange } = useContext(contractContext)
  const [formError, setFormError] = useState('')
  const [values, setValues] = useState({
    rent: '',
    condo: {
      paid: true,
      value: '',
    },
    iptu: {
      paid: true,
      value: '',
    },
  })

  const fetchProperty = async () => {
    try {
      const token = localStorage.getItem('accessToken')
      const property: PropertyAnnouncement = await getPropertyAnnouncement(contract.propertyId, token)
      return property
    } catch (e) {
      return null
    }
  }

  const getContextValues = async () => {
    let { values, tenant_pays } = contract
    if (contract.propertyId) {
      const property = await fetchProperty()

      if (property) {
        values = property.values
        tenant_pays = property.tenant_pays
      }
    }
    setValues({
      rent: values.rent ? currencyFloatToString(values.rent) : '',
      condo: {
        paid: tenant_pays.condo,
        value: values.condo ? currencyFloatToString(values.condo) : '',
      },
      iptu: {
        paid: tenant_pays.iptu,
        value: values.iptu ? currencyFloatToString(values.iptu) : '',
      },
    })
  }

  useEffect(() => {
    getContextValues()
    // eslint-disable-next-line
  }, [])

  const handleConfirm = () => {
    const { condo, iptu } = values

    if (!values.rent) {
      setFormError('Aluguel é um campo obrigatório')
      return
    }

    const propertyValuesObj = {
      tenant_pays: {
        rent: true,
        condo: condo.paid,
        iptu: iptu.paid,
      },
      values: {
        rent: currencyStringToFloat(values.rent),
        condo: currencyStringToFloat(condo.value),
        iptu: currencyStringToFloat(iptu.value),
      },
    }

    contract.contractDispatch({
      type: CONTRACT_ACTIONS.SET_CONTRACT_VALUES,
      value: propertyValuesObj,
    })

    handleStepChange('PaymentAndWarranty')
  }

  const getToggleLabel = (toggled) => (toggled ? toggleLabels.toggled : toggleLabels.nonToggled)

  const handleTogglePaid = (property) => {
    const newValue = {
      ...values,
      [property]: {
        ...values[property],
        paid: !values[property].paid,
      },
    }

    setValues(newValue)
  }

  const handleValuePaid = (value, property) => {
    const newValue =
      property === 'rent'
        ? {
            ...values,
            rent: value,
          }
        : {
            ...values,
            [property]: {
              ...values[property],
              value,
            },
          }

    setValues(newValue)
  }

  const currencyMask = createNumberMask({
    prefix: 'R$ ',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: '.',
    allowDecimal: true,
    decimalSymbol: ',',
    decimalLimit: 2, // how many digits allowed after the decimal
    integerLimit: 7, // limit length of integer numbers
    allowNegative: false,
    allowLeadingZeroes: false,
  })

  const totalValue = (() => {
    let total = 0
    Object.keys(values).forEach((property) => {
      if (property === 'rent') {
        total += currencyStringToFloat(values[property])
      }

      if (values[property].paid) {
        total += currencyStringToFloat(values[property].value)
      }
    })

    return total
  })()

  return (
    <div>
      <div className='rent-container'>
        <GeneralInputMask
          mask={currencyMask}
          value={values.rent}
          label='Aluguel'
          handleChange={(e) => handleValuePaid(e.target.value, 'rent')}
          error={formError}
        />
        <p style={{ fontSize: 12, margin: '4px 0 16px 0' }}>
          Este é o valor que você, como dono(a) deseja receber <br />
          líquido na sua conta. Caso você opte pelo seguro, <br />o valor adicional será aplicado na próxima
          etapa
        </p>
      </div>
      <div className='negotiated-value-row'>
        <GeneralInputMask
          value={values.condo.value}
          label='Condomínio'
          mask={currencyMask}
          handleChange={(e) => handleValuePaid(e.target.value, 'condo')}
        />
        <Toggle
          toggled={values.condo.paid}
          label={getToggleLabel(values.condo.paid)}
          id='condo'
          onClick={() => handleTogglePaid('condo')}
        />
      </div>
      <div className='negotiated-value-row'>
        <GeneralInputMask
          value={values.iptu.value}
          mask={currencyMask}
          label='IPTU'
          handleChange={(e) => handleValuePaid(e.target.value, 'iptu')}
        />
        <Toggle
          toggled={values.iptu.paid}
          label={getToggleLabel(values.iptu.paid)}
          id='IPTU'
          onClick={() => handleTogglePaid('iptu')}
        />
      </div>
      <div className='centralizer'>
        <ResultBox
          leftText={'VALOR TOTAL:'}
          rightText={`R$ ${String(totalValue.toFixed(2)).replace('.', ',')}`}
        />
      </div>
      <div className='end-aligner'>
        <div className='button-footer'>
          <Button title='Voltar' onClick={() => handleStepChange('ImmobileData')} />
          <Button title='CONFIRMAR' onClick={handleConfirm} />
        </div>
      </div>
    </div>
  )
}
